import styled from 'styled-components';

export const TopRatedStatus = styled.section`
    width: 100%;
    background: #DDF5F6;
    padding: 60px 0px 0;
     @media screen and (max-width:1024px){
         padding: 160px 0px 0;
     }
`;

export const TopRatedStatusTitle = styled.h2`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: 700;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 30px;
`;


export const TopRatedStatusTable = styled.section`
    width: 100%;
    padding: 0px 0px 60px;

    .table-section{
        background: #ddf5f6;
    }   

    .table-heading{
        tr{
            th{
                &:nth-child(4), &:nth-child(5){
                    display: none;
                }
            }
        }
    }
    .table_body{
        tr{
            td{
            vertical-align: middle;
                &:nth-child(4), &:nth-child(5){
                    display: none;
                }
            }
        }
    }
`;

export const MyNonprofitsTable = styled.section`
    background: #DDF5F6;
    .table-section{
        background: transparent;
    }
`;